import * as CryptoJS from 'crypto-js';

/**
 * Decrypt text
 * @param text
 * @param key
 * @returns string
 */
export const decrypt = (text: string, key: string): string => {
	return key
		? CryptoJS.AES.decrypt(text, key).toString(CryptoJS.enc.Utf8)
		: text;
};

/**
 * Encrypt text
 * @param text
 * @param key
 * @returns string
 */
export const encrypt = (text: string, key: string): string => {
	return key
		? CryptoJS.AES.encrypt(text, key).toString()
		: text;
};

/**
 * Uniques array. Removes duplicate entries of array
 * @template T
 * @param input
 * @returns array
 */
export function uniqueArray<T>(input: T[]): T[] {
	input = input.filter((item, pos) => input.indexOf(item) === pos);
	return input;
}

/**
 * Get hash of object
 * @param object
 * @returns number
 */
export function getHash(object: any): number {
	return JSON.stringify(object)
    .split('')
    .reduce((a: number, b: string) => {
      a = ((a << 5) - a) + b.charCodeAt(0);
      return a & a;
    }, 0);
}